import React from 'react'
import PerformanceTable from './PerformanceTable'
import { TableCell, Badge, MetricChange } from '../styles'

const MonthlyPerformanceTable = ({ data, onExport }) => {
  const headers = [
    { label: 'Month' },
    { label: 'Bookings', tooltip: 'Total appointments scheduled' },
    { label: 'Showed', tooltip: 'Patients who attended' },
    { label: 'No-Shows', tooltip: 'Patients who missed appointments' },
    { label: 'Show Rate', tooltip: 'Percentage of patients who showed up' },
    { label: 'Starts', tooltip: 'Patients who began treatment' },
    { label: 'Conv %', tooltip: 'Starts ÷ Bookings × 100' },
  ]

  const renderRow = month => {
    const conversion =
      month.bookings > 0
        ? ((month.starts / month.bookings) * 100).toFixed(1)
        : 0

    const showRate =
      month.bookings > 0
        ? ((month.showed_up / month.bookings) * 100).toFixed(1)
        : 0

    return (
      <>
        <TableCell>{month.month}</TableCell>
        <TableCell>{month.bookings}</TableCell>
        <TableCell>{month.showed_up}</TableCell>
        <TableCell>{month.no_shows}</TableCell>
        <TableCell>
          <Badge
            label={`${showRate}%`}
            color={
              showRate >= 80 ? 'success' : showRate >= 60 ? 'warning' : 'error'
            }
            size="small"
          />
        </TableCell>
        <TableCell>
          <Badge label={month.starts} color="primary" size="small" />
        </TableCell>
        <TableCell>
          <MetricChange $positive={conversion > 30}>{conversion}%</MetricChange>
        </TableCell>
      </>
    )
  }

  return (
    <PerformanceTable
      title="Monthly Performance"
      subtitle="Month-by-month summary of patient flow and conversion metrics"
      chipLabel={`${data?.length || 0} months`}
      onExport={onExport}
      headers={headers}
      data={data}
      renderRow={renderRow}
      emptyMessage="No monthly data available"
    />
  )
}

export default MonthlyPerformanceTable
